/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_verify_email_confirm_a_e_confirm_post } from '../models/Body_verify_email_confirm_a_e_confirm_post';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UrlAuthenticationService {
    /**
     * Auth Via Url
     * @param code
     * @returns string Successful Response
     * @throws ApiError
     */
    public static authViaUrlACodeGet(
        code: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/a/{code}',
            path: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Email Landing
     * @param userId
     * @param code
     * @returns string Successful Response
     * @throws ApiError
     */
    public static verifyEmailLandingAEUserIdCodeGet(
        userId: number,
        code: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/a/e/{user_id}/{code}',
            path: {
                'user_id': userId,
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Email Confirm
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static verifyEmailConfirmAEConfirmPost(
        formData: Body_verify_email_confirm_a_e_confirm_post,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/a/e/confirm',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
